import type { IsStringLiteral } from './literals/is-string-literal.type';

const UNESCAPED_SEPARATORS = ['[', ']', '{', '}', '(', ')', '|', '/', '-', '\\'] as const;
const SEPARATORS = [...UNESCAPED_SEPARATORS, ' ', '_', '.'] as const;

/** Escape characters with special significance in regular expressions */
const escapeChar = (char: string): string => {
  return (UNESCAPED_SEPARATORS as readonly string[]).includes(char) ? `\\${char}` : char;
};

export const SEPARATOR_REGEX = new RegExp(`[${SEPARATORS.map(escapeChar).join('')}]`, 'g');

/**
 * Checks if the given character is a separator.
 * E.g. space, underscore, dash, dot, slash.
 */
export type IsSeparator<TString extends string> =
  IsStringLiteral<TString> extends true ? (TString extends Separator ? true : false) : boolean;

export type Separator = (typeof SEPARATORS)[number];
